var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSideBarClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.167 9.334H3L9.583 2.75a.654.654 0 000-.917.654.654 0 00-.916 0L1 9.5c-.083.167-.167.25-.167.417 0 .167.084.333.167.417l7.583 7.583c.084.083.25.166.417.166a.636.636 0 00.417-.166.654.654 0 000-.917l-6.5-6.5h15.166c.334 0 .667-.25.667-.666 0-.417-.25-.5-.583-.5z",
    fill: "#fff"
  })));
}
export default SvgSideBarClose;